var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbarMoonGold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 8,
    fill: "url(#paint0_linear_1965_18421)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5302 19.9301C25.3702 19.6601 24.9202 19.2401 23.8002 19.4401C23.1802 19.5501 22.5502 19.6001 21.9202 19.5701C19.5902 19.4701 17.4802 18.4001 16.0102 16.7501C14.7102 15.3001 13.9102 13.4101 13.9002 11.3701C13.9002 10.2301 14.1202 9.13012 14.5702 8.09012C15.0102 7.08012 14.7002 6.55012 14.4802 6.33012C14.2502 6.10012 13.7102 5.78012 12.6502 6.22012C8.5602 7.94012 6.0302 12.0401 6.3302 16.4301C6.6302 20.5601 9.5302 24.0901 13.3702 25.4201C14.2902 25.7401 15.2602 25.9301 16.2602 25.9701C16.4202 25.9801 16.5802 25.9901 16.7402 25.9901C20.0902 25.9901 23.2302 24.4101 25.2102 21.7201C25.8802 20.7901 25.7002 20.2001 25.5302 19.9301Z",
    fill: "#1D1B18"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1965_18421",
    x1: 0,
    y1: 16.0011,
    x2: 32,
    y2: 16.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AB6E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#B47B23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#CDA243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121891,
    stopColor: "#E2C15B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171403,
    stopColor: "#F0D76D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.232867,
    stopColor: "#F9E477"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306282,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39399,
    stopColor: "#F9E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.504894,
    stopColor: "#EFD665"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635883,
    stopColor: "#E0C04B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#E8C853"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.808788,
    stopColor: "#FCE97B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F8E475"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#EED465"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#DDBB4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#C59826"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BA8916"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarMoonGold);
export default __webpack_public_path__ + "static/media/Navbar_Moon_Gold.3d0c9f8975ebc52d52ab1892d55cfd0d.svg";
export { ForwardRef as ReactComponent };